module.exports = __webpack_public_path__ + "assets/img/gk.png?22b9d92e0047bca9a9c51f37817b2095";